<template>
    <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>
                        <b-form-group>
                            <lg-form-input invalidFeedback="O número deve ser informado!" description=""
                                :error="$v.form.numero" v-model="form.numero" label="Número: *" />
                        </b-form-group>

                        <LgFinderPageTipoEmpenho v-model="form.tipoEmpenho" :value="form.tipoEmpenho"
                            id="finderTipoEmpenho" invalidFeedback="O tipo deve ser informada!" description=""
                            :prefix="updatedPrefix" :error="$v.form.tipoEmpenho" class="col-12" />
                        <LgFinderPageEmpresa v-model="form.empresa" :value="form.empresa" label="Empresa: *"
                            id="finderEmpresa" invalidFeedback="A empresa deve ser informado!" description=""
                            :prefix="updatedPrefix" class="col-12" :error="$v.form.empresa" />
                        <b-form-group>
                            <lg-form-date invalidFeedback="A data de emissão deve ser informada!" description=""
                                :error="$v.form.dtEmissao" v-model="form.dtEmissao" label="Data de emissão: *" />
                        </b-form-group>
                        <b-form-group>
                            <lg-form-date invalidFeedback="A data de entrega deve ser informada!" description=""
                                :error="$v.form.dtEntrega" v-model="form.dtEntrega" label="Data de entrega: *" />
                        </b-form-group>
                        <b-form-group>
                            <lg-form-input-number invalidFeedback="O valor total deve ser informado!" description=""
                                :error="$v.form.vlTotal" v-model="form.vlTotal" label="Valor total (R$): *"
                                :precision="{ min: 2, max: 2 }" :isMoney="true" />
                        </b-form-group>
                        <b-form-group>
                            <lg-form-input v-model="form.descricao" label="Descrição:" description="" />
                        </b-form-group>

                        <div class="d-flex justify-content-center mt-3">
                            <b-button id="salvarEmpenho" class=" my-2" size="sm" pill variant="success" @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarEmpenho" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarEmpenho" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarEmpenho" title="Cancelar"></b-tooltip>

                            </b-button>
                        </div>
                    </b-card>
                </b-form>
            </b-col>
        </b-row>
    </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";

import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormInputNumber from "@/core/components/Form/LgFormInputNumber.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageTipoEmpenho from "@/components/Finders/LgFinderPageTipoEmpenho.vue";
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue";

export default {
    components: {
        LgFormInput,
        LgFormInputNumber,
        LgFormDate,
        LgFinderPageTipoEmpenho,
        LgFinderPageEmpresa,
    },
    props: {
        isModal: Boolean,
        id: Number,
        prefix: Array,
        empresaNome: String,
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    mixins: [FormResourceMixin],
    data() {
        return {
            showModal: true,
            form: { descricao: "" },
        };
    },

    async beforeMount() {
        this.$statusService = new ResourceService(`/api/status`);
        this.$tiposEmpenhoService = new ResourceService(`/api/tiposempenho`);
        this.$service = new ResourceService(`/api/empenhos`);
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form = data;
        }
    },
    validations: {
        form: {
            numero: { required },
            empresa: { required },
            tipoEmpenho: { required },
            dtEmissao: { required },
            dtEntrega: { required },
            descricao: {},
            vlTotal: { required },
        },
    },
    methods: {
        cancelar() {
            this.$emit("close");
        },
        async statusList({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 });
        },
        async tiposEmpenhoList({ filter, page = 1 }) {
            return this.$tiposEmpenhoService.findAll({ filter, page, limit: 5 });
        },
        async save() {
            this.$v.$touch();
            if (!this.formIsValid) {
                this.$notify({
                    type: 'danger',
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            if (this.form.dtEmissao && this.form.dtEntrega) {
                const ini = new Date(this.form.dtEmissao);
                const fim = new Date(this.form.dtEntrega);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "A data de emissão não pode ser maior que a data de entrega.",
                    });
                    return;
                }
            }

            try {
                await this.$saveResource(this.form, "", true, {}, false, true);
                this.cancelar();
            }
            catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data,
                });
            }


        },
    },
};
</script>
